<app-key-combo-button
  icon="fas fa-search"
  [outlined]="false"
  size="small"
  label=""
  [keys]="['shift', 'k']"
  styleClass="p-button-shade"
  (action)="visible = true"></app-key-combo-button>

<p-dialog
  header="Header"
  (onShow)="search()"
  [(visible)]="visible"
  [modal]="true"
  position="top"
  [style]="{ width: '80rem' }">
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-3 w-full">
      <app-search-input
        [autofocus]="true"
        inputStyleClass="w-15rem"
        [searchValue]="queryString"
        placeholder="durchsuchen ..."
        (search)="updateQueryString($event)"></app-search-input>
      <app-tag-filter-dropdown
        styleClass="w-20rem"
        (selectedTagsChange)="updateQueryTags($event)"
        [selectedTags]="queryTags"
        [tagsInUse]="globalSearchStore.tagsInUse()" />
      @if (tree) {
        <p-treeSelect
          class="w-20rem"
          placeholder="Indikatoren durchsuchen ..."
          containerStyleClass="w-full"
          [(ngModel)]="queryCategory"
          (onNodeSelect)="callCategorySearch($event)"
          (onClear)="callCategorySearch()"
          [resetFilterOnHide]="true"
          [showClear]="true"
          [filter]="true"
          [options]="tree">
        </p-treeSelect>
      }
      <p-button
        class="ml-auto mr-3"
        [disabled]="!queryString && !queryTags.length && !queryCategory"
        icon="fas fa-filter-circle-xmark"
        [rounded]="true"
        [outlined]="true"
        (click)="resetQuery()"
        label="zurücksetzen"></p-button>
    </div>
  </ng-template>
  @if (results) {
    <p-tabMenu [model]="tabs" [activeItem]="activeTab">
      <ng-template pTemplate="item" let-item>
        <a
          pRipple
          [ngClass]="{
            'p-disabled': !results[item.key].length,
          }"
          class="flex align-items-center gap-2 p-menuitem-link">
          <i [class]="item.icon"></i>
          <span class="font-bold">
            {{ item.label }}
          </span>
          <p-badge [value]="results[item.key].length" />
        </a>
      </ng-template>
    </p-tabMenu>
    @if (
      indicatorSelection && indicatorSelection.length && active === 'indicators'
    ) {
      <div class="p-card p-3 my-3">
        <app-indicator-selection-list
          [indicatorIds]="indicatorSelection"
          (unselectEvent)="removeFromSelection($event)" />
        <p-divider />
        <footer class="flex justify-content-end gap-3">
          <a
            pButton
            (click)="resetFromSelection()"
            [text]="true"
            [rounded]="true"
            icon="fas fa-trash"
            label="Auswahl aufheben"></a>
          <a
            pButton
            (click)="initViewDialog()"
            [text]="true"
            [rounded]="true"
            icon="fas fa-eye"
            label="Im Atlas anzeigen"></a>
        </footer>
      </div>
    }
    @if (active && results[active] && results[active].length) {
      <p-table
        [value]="results[active]"
        [paginator]="results[active].length > 10"
        [rows]="10"
        [tableStyle]="{ 'min-width': '50rem' }"
        [alwaysShowPaginator]="false">
        <ng-template pTemplate="body" let-item>
          <tr
            *ngIf="
              active === 'indicators' && !indicatorSelection.includes(item._id)
            "
            app-table-row-indicator
            [item]="item"
            [fullName]="true"
            [actions]="
              hasDataWidgets
                ? ['info', 'generateView', 'addToAtlas', 'addToSelection']
                : ['info', 'generateView', 'addToSelection']
            "
            (generateViewEvent)="initViewDialog($event)"
            (addToSelectionEvent)="addToSelection($event)"
            (addToWidgetsEvent)="addToWidgets($event)"></tr>
          <tr
            *ngIf="active === 'dataLayerTypes'"
            app-table-row-data-layer-type
            [actions]="['generateView']"
            [item]="item"
            (generateViewEvent)="initViewDialog(undefined, $event)"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'bookmarks'"
            app-table-row-bookmark
            [actions]="['openInAtlas']"
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'topics'"
            app-table-row-topic
            [actions]="['openInAtlas']"
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'stories'"
            app-table-row-story
            [actions]="['openInAtlas']"
            [item]="item"
            (closeEvent)="close()"></tr>
          <tr
            *ngIf="active === 'districts'"
            app-table-row-district
            [item]="item"
            (closeEvent)="close()"></tr>
        </ng-template>
      </p-table>
    } @else if (results[active].length === 0) {
      <app-alert severity="secondary" styleClass="p-3" [canToggle]="false">
        <i>Wir konnten zu Ihrer Auswahl keine Inhalte finden.</i>
      </app-alert>
    }
  } @else {
    <app-alert [canToggle]="false">
      Suchen Sie nach Indikatoren, Ansichten, Berichte oder Teilräume und fügen
      Sie diese zum Dashboard hinzu.
    </app-alert>
  }

  <ng-template pTemplate="footer">
    <p-button
      class="mr-auto flex"
      icon="fas fa-times"
      [rounded]="true"
      [outlined]="true"
      label="schließen"
      severity="secondary"
      (onClick)="close()" />
  </ng-template>
</p-dialog>
<p-dialog [(visible)]="showGenerateViewDialog" [modal]="true">
  <ng-template pTemplate="headless">
    <div class="p-card border-round pt-1 p-4">
      <app-header
        icon="fas fa-wand-magic-sparkles"
        text="Automatische Ansicht generieren"></app-header>

      @if (
        showGenerateViewMode === 'indicator' &&
          indicatorStore.getById(indicatorSelection.at(0) || '');
        as indicator
      ) {
        <p class="flex">
          In welchem Raum wollen Sie "{{
            indicatorStore.getFullName(indicator, false)
          }}" anzeigen?
        </p>
        <app-type-dropdown
          [withIndicators]="[indicator._id]"
          [displayNewLayerTypeOption]="true"
          [(ngModel)]="dataLayerTypeToGenerateView"></app-type-dropdown>
      } @else {
        <p class="flex">
          Welche Indikatoren wollen Sie in "{{
            dataLayerTypeToGenerateView?.name
          }}" anzeigen?
        </p>
        <p-scrollPanel [style]="{ width: '100%', height: '20rem' }">
          <app-atlas-indicator-tree
            [withDataInType]="true"
            [selection]="indicatorSelection"
            (selectIndicator)="addToSelection($event)" />
        </p-scrollPanel>
      }
      <div class="text-sm text-color-secondary">
        <i class="fas fa-warning"></i> Ihre aktuelle Ansicht wird überschrieben
      </div>
      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="nein, abbrechen"
          (click)="closeAtlasDialog()"></button>
        <button
          [rounded]="true"
          [disabled]="!dataLayerTypeToGenerateView"
          pButton
          icon="fas fa-check"
          label="ja, übertragen"
          (click)="generateView()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
